<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="审批流程类型：" prop="ProcName">
          <el-input
            placeholder="审批流程类型"
            v-model="dataForm.ProcName"
            clearable
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="流程编码：" prop="ProcCode">
          <el-input
            placeholder="流程编码"
            v-model="dataForm.ProcCode"
            clearable
            maxlength="50"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="是否启用：">
          <el-switch
            v-model="dataForm.IsEnabled"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            @change="changeSwitch"
          ></el-switch>
        </el-form-item> -->

        <el-form-item label="审批流程：">
          <el-timeline>
            <el-timeline-item>发起</el-timeline-item>
            <el-timeline-item
              v-for="(step, index) in dataForm.Steps"
              :key="index"
            >
              <el-row>
                <div style="float:left;width:40%">
                  <el-form-item
                    label="审核步骤："
                    :prop="'Steps.' + index + '.StepName'"
                    :rules="editFormRules.StepName"
                  >
                    <el-input
                      placeholder="请输入审核步骤"
                      v-model="step.StepName"
                    ></el-input>
                  </el-form-item>
                </div>
                <div style="float:left;width:40%">
                  <el-form-item
                    label="审批者："
                    :prop="'Steps.' + index + '.PartName'"
                    :rules="editFormRules.PartName"
                  >
                    <el-input
                      placeholder="请按右侧图标选择"
                      v-model="step.PartName"
                    >
                      <i
                        slot="prefix"
                        :class="['el-input__icon', 'el-icon-user-solid']"
                        style="float:right;margin-right:25%"
                        @click="addUser(index)"
                      ></i>
                    </el-input>
                  </el-form-item>
                </div>
                <div>
                  <el-button
                    icon="el-icon-minus"
                    @click="subFlow(index)"
                    v-if="sub"
                    style="margin-left:10px"
                  ></el-button>
                </div>
              </el-row>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addFlow"
                v-if="add(index)"
                style="margin-left:40px;margin-top:10px"
              ></el-button>
            </el-timeline-item>
            <el-timeline-item>结束</el-timeline-item>
          </el-timeline>
        </el-form-item>
      </el-form>
      <employee-picker
        v-if="formVisible"
        @pickerCallBack="employeeCallBack"
      ></employee-picker>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import EmployeePicker from "@/modules/sys/components/picker/employee";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editFormRules: {
        ProcName: [
          { required: true, message: "审批流程类型不能空", trigger: "blur" }
        ],
        ProcCode: [
          { required: true, message: "栏目编码不能空", trigger: "blur" }
        ],
        StepName: [
          { required: true, message: "审核步骤不能空", trigger: "blur" }
        ],
        PartName: [{ required: true, message: "参与者不能空", trigger: "blur" }]
      },
      isConfirm: false,

      isAudit: 1, //是否审核
      steps: [{ StepName: "", PartName: "" }],
      formVisible: false,

      index: "",
      width: "60%"
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    add: function() {
      return index => {
        return (
          this.dataForm.Steps.length < 5 &&
          this.dataForm.Steps.length - 1 == index
        );
      };
    },

    sub: function() {
      return this.dataForm.Steps.length > 1;
    }
  },
  mounted() {
    this.loadStepData();
  },
  watch: {
    "dataForm.TypeName"(val) {
      window.console.log(val);
    }
  },
  components: {
    OfDialog,
    EmployeePicker
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //加载审批步骤
    loadStepData() {
      if (this.dataForm.Id) {
        this.isloading = true;
        let params={Id:this.dataForm.Id}
        api.QueryApprovalStep(params).then(rep => {
          if (rep.data.Code === 0) {
            this.isAudit = rep.data.Data.length === 0 ? 0 : 1;
            this.dataForm.Steps = rep.data.Data;
          }
          this.isloading = false;
        });
      }
    },
    //保存
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          this.dataForm.IsEnabled = 0;
          this.dataForm.ModifierId = this.GetCurrentUserInfo.Id;
          this.dataForm.Modifier = this.GetCurrentUserInfo.RealName;
          let params = Object.assign({}, this.dataForm);
          api.saveApprovalProcess(params)
            .then(rep => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    },
    //新增审核步骤
    addFlow() {
      this.dataForm.Steps.push({ StepName: "", PartName: "" });
    },
    //删除审核步骤
    subFlow(index) {
      this.dataForm.Steps.splice(index, 1);
    },
    //启用开关
    changeSwitch() {
      this.dataForm.IsEnabled === 0 ? 1 : 0;
    },
    //选择参与者
    addUser(index) {
      this.index = index;
      this.formVisible = true;
    },
    //人员选择回调
    employeeCallBack(val) {
      this.formVisible = false;
      if (val) {
        var result = this.dataForm.Steps.filter(item => {
          return item.PartName === val.RealName;
        });
        if (result.length != 0) {
          this.$message({
            message: "请勿重复添加",
            type: "warning"
          });
        } else {
          this.dataForm.Steps[this.index].PartName = val.RealName;
          this.dataForm.Steps[this.index].PartId = val.Id;
        }
      }
    }
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

/* .el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
} */

.el-input >>> .el-input__prefix {
  margin-left: 75%;
  margin-top: 2%;
}
</style>

<style>
.hide .el-button--primary {
  display: none;
}
</style>
